<template>
  <section>
    <!--工具条-->
    <el-col :span="4" class="toolbar">
      <el-button type="primary" size="small" @click="addFormVisible = true">新增</el-button>
    </el-col>
    <el-col :span="6" class="toolbar rightsearch">
      <el-input placeholder="名称、批次号、标识" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button></el-input>
    </el-col>

    <el-table :data="tableData"
              v-loading="listLoading">
      <el-table-column
        label="名称"
        prop="name"
        align="center">
      </el-table-column>
      <el-table-column
        label="批次号"
        prop="coupon_stock_id"
        align="center">
      </el-table-column>
      <el-table-column
        label="开始时间"
        prop="start_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="结束时间"
        prop="end_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="标识"
        prop="unique_key"
        align="center">
      </el-table-column>
      <el-table-column
        label="金额"
        prop="fee"
        align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        align="center">
        <template scope="scope">
          <el-button :plain="true" type="info" size="small" @click="showEditForm(scope.row)">修改</el-button>
          <el-button :plain="true" type="danger" size="small" @click="deleteDate(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible">
      <el-form :model="addForm" label-width="150px" :rules="formRules" ref="addForm">
        <el-form-item label="卡券名称" prop="name">
          <el-input v-model="addForm.name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="卡券批次号" prop="coupon_stock_id">
          <el-input v-model="addForm.coupon_stock_id" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="唯一标识" prop="unique_key">
          <el-input v-model="addForm.unique_key" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="金额" prop="fee">
          <el-input v-model="addForm.fee" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker
            v-model="addForm.start_time"
            type="datetime"
            placeholder="选择开始时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker
            v-model="addForm.end_time"
            type="datetime"
            placeholder="选择结束时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible">
      <el-form :model="editForm" label-width="200px" :rules="formRules" ref="editForm">
        <el-form-item label="卡券名称" prop="name">
          <el-input v-model="editForm.name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="卡券批次号" prop="coupon_stock_id">
          <el-input v-model="editForm.coupon_stock_id" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="唯一标识" prop="unique_key">
          <el-input v-model="editForm.unique_key" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="金额" prop="fee">
          <el-input v-model="editForm.fee" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker
            v-model="editForm.start_time"
            type="datetime"
            placeholder="选择开始时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker
            v-model="editForm.end_time"
            type="datetime"
            placeholder="选择结束时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import {formatPara} from '../../static/js/util.js';

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:15,
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
        addForm: {
          name: '',
          coupon_stock_id: '',
          unique_key: '',
          fee: '',
          start_time: '',
          end_time: '',
          status: 0
        },
        editFormVisible: false,
        editForm: {},
        formRules: {}
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/kaquan/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
        })
      },
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.addForm));
              para.fee = parseInt(para.fee);
              //异步请求
              this.$axios.post(config.api_url + '/kaquan',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'warning'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.editForm));
              para.fee = parseInt(para.fee);
              //异步请求
              this.$axios.put(config.api_url + '/kaquan',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      deleteDate(id) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.delete(config.api_url + '/kaquan/' + id
          ).then(response => {
            if(response.data.state) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.search();
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              });
            }
          }).catch(error => {
            this.$message({
              message: '删除异常，请联系管理员',
              type: 'error'
            });
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      showEditForm(row) {
        this.editFormVisible = true;
        this.editForm = row;
      },
    },
    created() {
      this.search();
    }
  }
</script>

<style scoped>
  .rightsearch{
    float: right;
  }
  .user-font {
    font-weight: 600;
    font-size: 15px;
    color: #48576a;
  }
</style>



// WEBPACK FOOTER //
// List.vue?c615437e